import { Helmet } from 'react-helmet-async';
import { Content } from './components/Content';
import { PageProvider } from './providers/PageProvider';

export const AdminWorkspacesListPage = () => {
  return (
    <>
      <Helmet>
        <title>Workspace list - AutoScript Admin</title>
      </Helmet>
      <PageProvider>
        <Content />
      </PageProvider>
    </>
  );
};
